import { makeStyles } from "@material-ui/core/styles";
import { secondary, grey300 } from "../../../infrastructure/theme/customColors";

const useStyles = makeStyles(() => ({
  linkStyle: {
    fontSize: "12px",
    lineHeight: "14px",
    color: secondary,
    cursor: "pointer",
    position: "absolute",
    right: 0,
  },
  disabledStyle: {
    color: grey300,
  },
}));

export default useStyles;
